<template>
  <b-modal class="modal-lg" id="addRuleModal" ref="add-rule-modal" :title="modal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @hide="cleanForm();resetModal();">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'plus']" size="1x" class="mr-2"/> {{ modal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <template v-if="!hasConflict">
        <div class="col-12 row mx-0">
          <!--<label for="exceptionType" class="d-block text-center">{{t('exceptionType','exceptionType')}}</label>-->
          <div class="col-12 text-left px-0 mt-2 mb-2" style="border-bottom: 1px solid #ccc;">{{ t('exceptionTypeLabel', 'exceptionTypeLabel') }}</div>
          <select id="exceptionType" @change="setRuleDescription($event); setDefaultValues($event)" v-model="newException.rule_number" ref="ruleSelect" class="form-control custom-select text-capitalize">
            <option :value="null" disabled>{{t('selectRuleOption', 'selectRuleOption')}}</option>
            <template v-for="rule in rules">
              <option :value="rule.id" :data-desc="rule.description_long">{{t(rule.description_short, rule.description_short)}}</option>
            </template>
          </select>
        </div>
        <div v-if="newException.rule_number" class="col-12 row mx-0">
          <div class="col-12 px-0 row mx-0">
            <small class="rule-desc">{{ t(ruleDescription, ruleDescription) }}</small>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 px-0">
            <div class="col-12 text-left px-0 mt-2 mb-2" style="border-bottom: 1px solid #ccc;">{{ t('exceptionDescriptionLabel', 'exceptionDescriptionLabel') }}</div>
            <input id="description" v-model="newException.description" class="form-control" :placeholder="t('descriptionPlaceholder', 'descriptionPlaceholder')" type="text">
          </div>
          <div class="col-12 px-0 mt-2 mb-2" style="border-bottom: 1px solid #ccc;">{{ t('filterAttributesHeader', 'filterAttributesHeader') }}</div>
          <template v-for="input in formAttributesWithData">
            <template v-for="data in input">
              <template v-if="(data.type == 'text') && (data.title != 'ruleId') && (data.title != 'description')">
                <template v-if="Array.isArray(data.exceptionRule)">
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <label :for="data.title + '-exception-rule'" class="d-block text-center">{{t('operation','operation')}}</label>
                    <select :id="data.title + '-exception-rule'" v-model="newException[data.name + '_exception_operation']" class="form-control custom-select text-capitalize">
                      <option v-for="exRule in data.exceptionRule" :value="exRule" :key="exRule">{{ t('operation_' + exRule, 'operation_' + exRule) }}</option>
                    </select>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <label :for="data.title" class="d-block text-center">{{t(data.title, data.title)}}</label>
                    <input :disabled="!newException[data.name + '_exception_operation']" :id="data.title" v-model="newException[data.name]" class="form-control" :placeholder="t(data.title,data.title)" type="text">
                  </div>
                </template>
                <template v-else>
                  <div class="col-12 px-0">
                    <label :for="data.title" class="d-block text-center">{{t(data.title, data.title)}}</label>
                    <input :disabled="!newException[data.name + '_exception_operation']" :id="data.title" v-model="newException[data.name]" class="form-control" :placeholder="t(data.title,data.title)" type="text">
                  </div>
                </template>
              </template>
              <template v-if="(data.type == 'list')">
                <template v-if="data.name == 'batch_type'">
                  <div class="col-12 px-0">
                    <label :for="data.title" class="d-block text-center">{{ t(data.title, data.title) }}</label>
                    <select :id="data.title" v-model="newException[data.name]" class="form-control custom-select text-capitalize">
                      <template v-if="data.name == 'batch_type'">
                        <option :value="null"> {{ t('batchAllOption', 'batchAllOption') }}</option>
                        <option v-for="batchType in batchTypes" :value="batchType.id" :key="batchType.id">{{ batchType.name }}</option>
                      </template>
                      <template v-else-if="data.name == 'document_type'">
                        <option v-for="documentType in documentTypes" :value="documentType.id" :key="documentType.id">{{ documentType.name }}</option>
                      </template>
                    </select>
                  </div>
                </template>
              </template>
              <template v-if="(data.type == 'multiple') && (data.title != 'enabled')">
                <template v-if="Array.isArray(data.exceptionRule)">
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <label :for="data.title + '-exception-rule'" class="d-block text-center">{{t('operation','operation')}}</label>
                    <select :id="data.title + '-exception-rule'" @change="clearExceptionRule(data.name)" v-model="newException[data.name + '_exception_operation']" class="form-control custom-select text-capitalize">
                      <option selected :value="null">{{ t('noOperationOption', 'noOperationOption') }}</option>
                      <option v-for="exRule in data.exceptionRule" :value="exRule" :key="exRule">{{ t('operation_' + exRule, 'operation_' + exRule) }}</option>
                    </select>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <label :for="data.title" class="d-block text-center">{{ t(data.title,data.title) }}</label>
                    <select :disabled="!newException[data.name + '_exception_operation']" :multiple="newException[data.name + '_exception_operation'] && ( newException[data.name + '_exception_operation'] == 'in_list' || newException[data.name + '_exception_operation'] == 'not_in_list')" :id="data.title" v-model="newException[data.name]" class="form-control custom-select text-capitalize">
                      <option :value="undefined" selected disabled>{{t('selectNone','selectNone') }}</option>
                      <template v-if="data.name == 'customer_type'">
                        <option v-for="customerType in data.values" :value="customerType.id" :key="customerType.value_code">{{ customerType.value_name }}</option>
                      </template>
                      <template v-if="data.name == 'invoice_type'">
                        <option v-for="invoiceType in data.values" :value="invoiceType.id" :key="invoiceType.value_code">{{ invoiceType.value_name }}</option>
                      </template>
                      <template v-if="data.name == 'document_type'">
                        <option v-for="documentType in documentTypes" :value="documentType.id" :key="documentType.id">{{ documentType.name }}</option>
                      </template>
                      <template v-if="data.name == 'batch_type'">
                        <option :value="null"> {{ t('batchAllOption', 'batchAllOption') }}</option>
                        <option v-for="batchType in batchTypes" :value="batchType.id" :key="batchType.id">{{ batchType.name }}</option>
                      </template>
                      <template v-if="(data.name == 'entity') || (data.title == 'country')">
                        <option v-for="entity in entities" :value="entity.id" :key="entity.id">{{ entity.combined_name }}</option>
                      </template>
                      <template v-if="data.name == 'entity_code'">
                        <option v-for="entityCode in data.values" :value="entityCode.id" :key="entityCode.value_code">{{ entityCode.value_name }}</option>
                      </template>
                      <template v-if="data.name == 'brand'">
                        <option v-for="brand in brands" :value="brand.id" :key="brand.id">{{ brand.brand }}</option>
                      </template>
                    </select>
                  </div>
                </template>
                <template v-else>
                  <div class="col-12 px-0">
                    <label :for="data.title" class="d-block text-center">{{t(data.title,data.title)}}</label>
                    <select :id="data.title" v-model="newException[data.name]" :multiple="data.multiple" :select-size="4" class="form-control custom-select text-capitalize">
                      <option :value="undefined" selected disabled>{{t('selectNone','selectNone') }}</option>
                      <template v-if="data.name == 'customer_type'">
                        <option v-for="customerType in data.values" :value="customerType.id" :key="customerType.value_code">{{ customerType.value_name }}</option>
                      </template>
                      <template v-if="data.name == 'invoice_type'">
                        <option v-for="invoiceType in data.values" :value="invoiceType.id" :key="invoiceType.value_code">{{ invoiceType.value_name }}</option>
                      </template>
                      <template v-if="data.name == 'document_type'">
                        <option v-for="documentType in documentTypes" :value="documentType.id" :key="documentType.id">{{ documentType.name }}</option>
                      </template>
                      <template v-if="data.name == 'batch_type'">
                        <option :value="null"> {{ t('batchAllOption', 'batchAllOption') }}</option>
                        <option v-for="batchType in batchTypes" :value="batchType.id" :key="batchType.id">{{ batchType.name }}</option>
                      </template>
                      <template v-if="(data.name == 'entity') || (data.title == 'country')">
                        <option v-for="entity in entities" :value="entity.id" :key="entity.id">{{ entity.combined_name }}</option>
                      </template>
                      <template v-if="data.name == 'entity_code'">
                        <option v-for="entityCode in data.values" :value="entityCode.id" :key="entityCode.value_code">{{ entityCode.value_name }}</option>
                      </template>
                      <template v-if="data.name == 'brand'">
                        <option v-for="brand in brands" :value="brand.id" :key="brand.id">{{ brand.brand }}</option>
                      </template>
                    </select>
                  </div>
                </template>
              </template>
              <template v-if="data.type == 'radio'">
                <template v-for="radioValue in data.values">
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <b-form-group class="mt-0" :label="t(radioValue.value_code, radioValue.value_code)">
                      <b-form-radio v-model="newException[data.name]" :name="radioValue.value_code" :value="radioValue.value_name">
                        {{ t(radioValue.value_name,radioValue.value_name) }}
                      </b-form-radio>
                    </b-form-group>
                  </div>
                </template>
              </template>
              <template v-if="data.type == 'check'">
                <div class="col-sm-12 col-md-6 col-lg-6 mt-2">
                  <b-form-checkbox
                    v-model="newException[data.name]"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0"
                  >
                    {{ t(data.title, data.title) }}
                  </b-form-checkbox>
                </div>
              </template>
            </template>
          </template>
          <template v-if="rules">
            <div class="col-12 text-left mt-2 mb-2" style="border-bottom: 1px solid #ccc;">{{ t('ruleAttributesLabel', 'ruleAttributesLabel') }}</div>
          </template>
          <template v-for="rule in rules">
            <template v-if="newException.rule_number == rule.id">
              <template v-if="rule.rule_attributes">
                <div class="my-2 col-12 row">
                  <template v-for="ruleAttribute in rule.rule_attributes">
                      <template v-if="ruleAttribute.rule_attribute_type == 'text'">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                          <label :for="'attribute_text_' + ruleAttribute.rule_attribute_id" class="d-block text-center">{{ t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title) }}</label>
                          <input :id="'attribute_text_' + ruleAttribute.rule_attribute_id" v-model="newException.rule_attributes[ruleAttribute.rule_id][ruleAttribute.rule_attribute_title]" class="form-control" type="text">
                        </div>
                      </template>
                      <template v-if="ruleAttribute.rule_attribute_type == 'textarea'">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                          <label :for="'attribute_textarea_' + ruleAttribute.rule_attribute_id" class="d-block text-center">{{t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title)}}</label>
                          <b-form-textarea
                            :id="'attribute_textarea_' + ruleAttribute.rule_attribute_id"
                            v-model="newException.rule_attributes[ruleAttribute.rule_id][ruleAttribute.rule_attribute_title]"
                            rows="3"
                            max-rows="6"
                          ></b-form-textarea>
                        </div>
                      </template>
                      <template v-if="ruleAttribute.rule_attribute_type == 'multiple' || ruleAttribute.rule_attribute_type == 'list'">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                          <label :for="'attribute_list_' + ruleAttribute.rule_attribute_id" class="d-block text-center">{{t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title)}}</label>
                          <select :id="'attribute_list_' + ruleAttribute.rule_attribute_id" v-model="newException.rule_attributes[ruleAttribute.rule_id][ruleAttribute.rule_attribute_title]" class="form-control custom-select">
                            <option disabled value="undefined">{{t('selectAnOption', 'selectAnOption')}}</option>
                            <option v-for="option in ruleAttribute.rule_attribute_options" :key="option.rule_attribute_title" :value="option.attribute_option_name">
                              {{ t(option.attribute_option_name, option.attribute_option_name) }}
                            </option>
                          </select>
                        </div>
                      </template>
                      <template v-if="ruleAttribute.rule_attribute_type == 'radio'">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                          <label :for="'attribute_radio_' + ruleAttribute.rule_attribute_id" class="d-block text-center">{{t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title)}}</label>
                          <b-form-checkbox-group :id="'attribute_radio_' + ruleAttribute.rule_attribute_id">
                            <b-form-radio v-for="option in ruleAttribute.rule_attribute_options" :key="option.attribute_option_name" :name="ruleAttribute.rule_attribute_title" :value="option.attribute_option_name" v-model="newException.rule_attributes[ruleAttribute.rule_id][ruleAttribute.rule_attribute_title]" class="col-sm-12 col-md-6 col-lg-6">
                              {{t(option.attribute_option_name, option.attribute_option_name)}}
                            </b-form-radio>
                          </b-form-checkbox-group>
                        </div>
                      </template>
                      <template v-if="ruleAttribute.rule_attribute_type == 'check'">
                        <div class="col-sm-12">
                          <template v-if="ruleAttribute.rule_attribute_options">
                            <label :for="'attribute_check_' + ruleAttribute.rule_attribute_id" class="d-block text-center">{{t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title)}}</label>
                            <b-form-checkbox-group :id="'attribute_check_' + ruleAttribute.rule_attribute_id" v-model="newException.rule_attributes[ruleAttribute.rule_id][ruleAttribute.rule_attribute_title]" class="mt-1">
                              <b-form-checkbox v-for="option in ruleAttribute.rule_attribute_options" :key="option.rule_attribute_title" :value="1" unchecked-value="0">
                                {{t(option.rule_attribute_title, option.rule_attribute_title)}}
                              </b-form-checkbox>
                            </b-form-checkbox-group>
                          </template>
                          <template v-else>
                            <b-form-checkbox-group v-model="newException.rule_attributes[ruleAttribute.rule_id][ruleAttribute.rule_attribute_title]" class="mt-1">
                              <b-form-checkbox :value="1" unchecked-value="0">
                                {{t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title)}}
                              </b-form-checkbox>
                            </b-form-checkbox-group>
                          </template>
                        </div>
                      </template>
                  </template>
                </div>
              </template>
            </template>
          </template>
        </div>
        
        <div class="col-12 row mx-0" v-if="newException.rule_number">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <b-form-checkbox
              v-model="newException.enabled"
              value="enabled"
              unchecked-value="disabled"
            >
            {{t('ruleIsEnabled','ruleIsEnabled')}}
            </b-form-checkbox>
          </div>
        </div>
      </template>

      <template v-else>
        <h5>{{t('conflictDetected','conflictDetected')}}</h5>
        <p>{{t('sendExceptionRuleConflictOnAddDescription','sendExceptionRuleConflictOnAddDescription')}}</p>
        <table class="table table-striped">
          <thead class="brand-color">
            <tr>
              <th scope="col">{{t('type', 'type')}}</th>
              <template v-for="input in formAttributesWithData">
                <template v-for="data in input">
                  <th scope="col">
                    {{t(data.label, data.label)}}
                  </th>
                </template>
              </template>
              <th scope="col">{{t('rule', 'rule')}}</th>
            </tr>
          </thead>
          <tr>
            <th scope="row">{{t('existingRule', 'existingRule')}}</th>
            <template v-for="input in formAttributesWithData">
              <template v-for="data in input">
                <template>
                  <th v-if="getResponseInfo.conflictingRule[data.name] && (getResponseInfo.conflictingRule[data.name] != 0)" class="text-center">
                    <template v-if="data.name == 'batch_type'">
                      <template v-if="getResponseInfo.conflictingRule['batch_type_name']">
                        {{ getResponseInfo.conflictingRule['batch_type_name'] }}
                      </template>
                      <template v-else>
                        {{ getResponseInfo.conflictingRule[data.name] }}
                      </template>
                    </template>
                    <template v-else>
                      {{getResponseInfo.conflictingRule[data.name]}}
                    </template>
                  </th>
                  <th v-else class="text-center"> - </th>
                </template>
              </template>
            </template>
            <th scope="row">{{getResponseInfo.conflictingRule['rule_description']}}</th>
          </tr>
          <tr>
            <th scope="row">{{t('newRule', 'newRule')}}</th>
            <template v-for="input in formAttributesWithData">
              <template v-for="data in input">
                <template v-if="(data.name != 'rule_id')">
                  <th v-if="getResponseInfo.ruleToBeAdded[data.name] && (getResponseInfo.ruleToBeAdded[data.name] != 0)" class="text-center">
                    <template v-if="data.name == 'batch_type'">
                      <template v-if="getResponseInfo.ruleToBeAdded['batch_type_name']">
                        {{ getResponseInfo.ruleToBeAdded['batch_type_name'] }}
                      </template>
                      <template v-else>
                        {{ getResponseInfo.ruleToBeAdded[data.name] }}
                      </template>
                    </template>
                    <template v-else>
                      {{getResponseInfo.ruleToBeAdded[data.name]}}
                    </template>
                  </th>
                  <th v-else class="text-center"> - </th>
                </template>
                <template v-else-if="data.name == 'rule_id'">
                  <th class="text-center"> - </th>
                </template>
              </template>
            </template>
            <th scope="row">{{getResponseInfo.ruleToBeAdded['rule_description']}}</th>
          </tr>
        </table>
        <div class="col-12 row justify-content-end">
          <button class="btn btn-success" type="button" @click="cancelForm()">
            <fontAwesomeIcon :icon="['fa', 'check']" size="1x" class="mr-2"/>{{ t('keepExistingRuleButtonText', 'keepExistingRuleButtonText')}}
          </button>
          <button class="btn btn-danger ml-2" type="button" @click="addRule({type: 'discardExisting', id: getResponseInfo.conflictingRule.rule_id})">
            <fontAwesomeIcon :icon="['fa', 'times']" size="1x" class="mr-2"/>{{ t('discardExistingRuleButtonText', 'discardExistingRuleButtonText')}}
          </button>
          <button class="btn btn-secondary ml-2" type="button" @click="addConflictingRule({type: 'addConflictingRule'})">
            <fontAwesomeIcon :icon="['fa', 'plus']" size="1x" class="mr-2"/>{{ t('ignoreRuleConflictButonText', 'ignoreRuleConflictButonText')}}
          </button>
        </div>
      </template>

      <div ref="message">
        <ResponseInfo class="mt-3" v-if="(getResponseInfo.responseName == 'addModal') && (getResponseInfo.status == 'error') && !hasConflict"></ResponseInfo>
      </div>

    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
      </button>
      <template v-if="modal.modalData && !hasConflict">
        <div v-if="buttonIsBusy">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
        <button v-if="!buttonIsBusy" :disabled="!newException.rule_number" aria-label="AddRule" data-dismiss="modal" class="btn btn-primary" type="button" @click="addRule()">
          <fontAwesomeIcon :icon="['fa', 'plus']" size="1x" class="mr-2"/>{{ t('addRuleButtonText', 'addRuleButtonText')}}
        </button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import { clientShortName } from '@/helpers/clientShortName.js'

export default {
  name: 'add_rule_modal',
  inject: [
    'modal',
    'resetModal',
    'refreshResults'
  ],
  data () {
    return {
      buttonIsBusy: false,
      newExceptionType: [],
      ruleDescription: '',
      newException: {
        rule_attributes: {},
        enabled: 'enabled'
      }
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    formAttributes() {
      return this.$store.getters['sendExceptionsStore/getSendExceptionRulesAttributes']
    },
    formAttributesWithData() {
      return this.$store.getters['sendExceptionsStore/getSendExceptionRulesSearchFilters']
    },
    instructionFormAttributes() {
      return this.$store.getters['sendExceptionsStore/getSendExceptionInstructions']
    },
    documentTypes() {
      return this.$store.getters['sendExceptionsStore/getDocTypes']
    },
    batchTypes() {
      return this.$store.getters['sendExceptionsStore/getBatchTypes']
    },
    entities() {
      return this.$store.getters['sendExceptionsStore/getEntities']
    },
    brands() {
      return this.$store.getters['sendExceptionsStore/getBrands']
    },
    rules() {
      return this.$store.getters['sendExceptionsStore/getRules']
    },
    hasConflict() {
      let response = this.getResponseInfo
      if(response.key == "conflictFound") {
        return true
      } else {
        return false
      }
    },
    clientName() {
			let clientName = clientShortName()
			return clientName
		}
  },
  methods:{
    setRuleDescription(event) {
      let option = this.$refs.ruleSelect.selectedOptions[0].dataset
      this.ruleDescription = option.desc
    },
    setDefaultValues(event) {
      // if rule is selected/changed clear old attributed and prepare defaults for new one
      let ruleNumber = event.target.value
      if(this.newException) {
        this.newException.document_value = 0
        if(this.newException.rule_attributes) {
          for (const [key, value] of Object.entries(this.newException.rule_attributes)) {
            if(key == this.newException.rule_number) {
              if(this.rules[this.newException.rule_number] && this.rules[this.newException.rule_number].rule_attributes) {
                let attributes = this.rules[this.newException.rule_number].rule_attributes

                if(attributes) {
                  attributes.forEach((value, index) => {
                    if(attributes[index].rule_attribute_title == 'apply_to_documents') {
                      this.newException.rule_attributes[this.newException.rule_number]['apply_to_documents'] = 'allFutureDocuments'
                    } else if (attributes[index].rule_attribute_title == 'number_of_copies') {
                      this.newException.rule_attributes[this.newException.rule_number]['number_of_copies'] = 0
                    } else if (attributes[index].rule_attribute_title == 'is_copy_stamp_required') {
                      this.newException.rule_attributes[this.newException.rule_number]['is_copy_stamp_required'] = 0
                    } else if (attributes[index].rule_attribute_title == 'disable_and_hide_if') {
                      this.newException.rule_attributes[this.newException.rule_number]['disable_and_hide_if'] = '<='
                    } else if (attributes[index].rule_attribute_title == 'disable_and_hide_if_value') {
                      this.newException.rule_attributes[this.newException.rule_number]['disable_and_hide_if_value'] = 0
                    } else if(attributes[index].rule_attribute_title == 'address') {
                      this.newException.rule_attributes[this.newException.rule_number]['address'] = ''
                    } else if(attributes[index].rule_attribute_title != 'is_copy_stamp_required' && attributes[index].rule_attribute_type == 'check') {
                      this.newException.rule_attributes[this.newException.rule_number][attributes[index].rule_attribute_title] = 0
                    }
                  });
                }
              } else {
                this.newException.rule_attributes[key] = {}
              }
            } else {
              this.newException.rule_attributes[key] = {}
            }
            
          }
        }
      }
    },
    inRuleTypes(type) {
      return type
    },
    addRule(addType = {type: 'normal'}) {
      let data = {}
      data.newException = this.newException
      data.newExceptionType = addType

      this.$store.dispatch('sendExceptionsStore/addNewSendException', data)
      .then(() => {
        let response = this.getResponseInfo
        
        if(response.status == 'success') {
          this.newException.rule_number = null
          this.refreshResults()
          this.$refs['add-rule-modal'].hide()
        }
        if(response.status == 'error'){
          this.$refs['message'].scrollIntoView()
        }
      })
    },
    addConflictingRule(ruleType) {
      let data = {}
      data.newException = this.newException
      data.newExceptionType = ruleType
      if(data) {
        this.$store.dispatch('sendExceptionsStore/addNewSendException', data)
        .then(() => {
          let response = this.getResponseInfo
          
          if(response.status == 'success') {
            this.newException.rule_number = null
            this.refreshResults()
            this.$refs['add-rule-modal'].hide()
          }
          if(response.status == 'error'){
            this.$refs['message'].scrollIntoView()
          }
        })
      }
    },
    cancelForm() {
      this.cleanForm()
      this.$refs['add-rule-modal'].hide()
    },
    cleanForm() {
      //this.newExceptionRule = 0
      this.newExceptionType = []

      //resetting the form with the correct default values
      let attributes = this.newException.rule_attributes
      for (const formDataIndex in this.newException) {
        if(formDataIndex == 'rule_attributes'){
          for (const attributeIndex in attributes) {
            this.newException.rule_attributes[attributeIndex] = {}
          }
        } else {
          if(formDataIndex == 'enabled') {
            this.newException.enabled = 'enabled'
          } else {
            if(Array.isArray(this.newException[formDataIndex])) {
              this.newException[formDataIndex] = []
            } else {
              this.newException[formDataIndex] = null
            }
          }
        }
      }
    },
    clearExceptionRule(name) {
      if(this.newException[name]) {
        this.newException[name] = new Array()
      }     
    }
  },
  created() {
    //fetching the rules
    this.$store.dispatch('sendExceptionsStore/getRules').then(
      () => {
        for (const ruleIndex in this.rules) {
          //prepare the objects that will hold the rule attribute values
          //indexed by their rule's id
          //we need this otherwise vuejs won't know where to put the data
          this.newException.rule_attributes[this.rules[ruleIndex].id] = {}
        }
      }
    )

    //we fetch these standard attribute lists only if the client has them set
    this.$store.dispatch('sendExceptionsStore/getSendExceptionRulesAttributes').then(
      () => {
        if(this.formAttributes.includes('batch_type')) {
          this.$store.dispatch('sendExceptionsStore/getBatchTypes')
        }

        if(this.formAttributes.includes('entity')) {
          this.$store.dispatch('sendExceptionsStore/getEntities')
        }

        if(this.formAttributes.includes('brand')) {
          this.$store.dispatch('sendExceptionsStore/getBrands')
        }

        if(this.formAttributes.includes('document_type')) {
          this.$store.dispatch('sendExceptionsStore/getDocumentTypes')
        }
      }
    )
    this.$store.dispatch('sendExceptionsStore/getSendExceptionRulesSearchFilters').then(
      () => {
        for (const attributeTypeListIndex in this.formAttributesWithData) {
          for (const attributeIndex in this.formAttributesWithData[attributeTypeListIndex]) {
            if((this.formAttributesWithData[attributeTypeListIndex][attributeIndex]['type'] == 'multiple')
            && (this.formAttributesWithData[attributeTypeListIndex][attributeIndex]['name'] != 'enabled')){
              this.newException[this.formAttributesWithData[attributeTypeListIndex][attributeIndex]['name']] = []
            }
          }
        }
      }
    )
  },
  components:{
    ResponseInfo
  }
}
</script>
<style scoped>
  table >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }

  .modal-open #addRuleModal___BV_modal_outer_ >>> .modal-dialog{
    display: flex !important;
    justify-content: center !important;
  }
  .modal-open #addRuleModal___BV_modal_outer_ >>> .modal-content{
    min-width: 950px !important;
    max-width: auto !important;
    width: auto !important;
  }
  .modal-open #addRuleModal___BV_modal_outer_ >>> .modal-content .modal-body{
    max-height: 600px;
    overflow-y: scroll;
  }

  .form-extra-background{
    background-color: #eeeeee;
    padding: 5px;
    border-radius: 5px;
  }

  .rule-desc {
    color: #047bf8;
  }
</style>
